import { render, staticRenderFns } from "./SubtitlesEditCard.vue?vue&type=template&id=18e5bdd3&scoped=true"
import script from "./SubtitlesEditCard.vue?vue&type=script&lang=js"
export * from "./SubtitlesEditCard.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesEditCard.vue?vue&type=style&index=0&id=18e5bdd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5bdd3",
  null
  
)

export default component.exports